import React, { useEffect, useState } from 'react';
import api from '../services/api';

import { Search, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

// Labels para sub-status das equipes
const STATUS_LABEL_LEAD = { aguardando_vendedor:'Aguard. Vendedor', visita:'Visita Agendada', proposta:'Proposta Enviada', fechado:'Venda Fechada', perdido:'Desistiu da Compra', em_espera:'Aguard. Cliente' };
const STATUS_LABEL_POS  = { aguardando:'Aguard. Pós Venda', na_transportadora:'Na Transportadora', instalando:'Instalando', finalizado:'Finalizado' };
const STATUS_LABEL_ENG  = {
  aguardando_engenheiro:'Aguard. Engenheiro', realizando_planejamento:'Planejando',
  aguardando_cemig:'Aguard. CEMIG', documentacao_aprovada:'Doc. Aprovada', vistoria_feita:'Vistoria Feita',
  // legado
  aguardando:'Aguard. Engenheiro', instalacao_programada:'Planejando',
  realizando_instalacao:'Aguard. CEMIG', instalacao_concluida:'Vistoria Feita',
};
const STATUS_LABEL_INST = { aguardando_instalador:'Aguard. Instalador', instalacao_programada:'Inst. Programada', instalando:'Instalando', instalacao_concluida:'Concluída' };
const STATUS_LABEL_FIN  = { aguardando:'Aguard. Financeiro', aguardando_pagamento:'Aguard. Pagamento', pago:'Pago' };

const ALL_COLORS = {
  aguardando:'#64748b', na_transportadora:'#fb923c', finalizado:'#4ade80',
  // engenheiro (novos)
  aguardando_engenheiro:'#64748b', realizando_planejamento:'#60a5fa',
  aguardando_cemig:'#fbbf24', documentacao_aprovada:'#a78bfa', vistoria_feita:'#4ade80',
  // instalador
  aguardando_instalador:'#64748b', instalacao_programada:'#60a5fa',
  instalando:'#a78bfa', instalacao_concluida:'#4ade80',
  aguardando_pagamento:'#60a5fa', pago:'#4ade80',
  aguardando_vendedor:'#94a3b8', visita:'#fb923c', proposta:'#f6c90e',
  fechado:'#4ade80', perdido:'#f87171', em_espera:'#f59e0b',
};

const S = {
  heading: { fontSize:22, fontWeight:700, color:'#f6c90e', marginBottom:4 },
  sub: { fontSize:13, color:'#475569', marginBottom:24 },
  filters: { display:'flex', gap:10, marginBottom:20, flexWrap:'wrap', alignItems:'center' },
  searchBox: { display:'flex', alignItems:'center', gap:8, background:'#0e1420', border:'1px solid #1a2035', borderRadius:8, padding:'8px 12px', flex:1, maxWidth:300 },
  searchInput: { background:'none', border:'none', color:'#e2e8f0', fontSize:13, outline:'none', flex:1 },
  filterBtn: (active, color) => ({
    padding:'7px 14px', borderRadius:20, border:`1px solid ${color}44`,
    background: active ? `${color}22` : 'transparent',
    color: active ? color : '#475569', fontSize:12, fontWeight:600, cursor:'pointer',
  }),
  table: { width:'100%', borderCollapse:'collapse' },
  th: { padding:'10px 14px', textAlign:'left', fontSize:11, color:'#475569', textTransform:'uppercase', letterSpacing:1, borderBottom:'1px solid #1a2035', whiteSpace:'nowrap' },
  td: { padding:'12px 14px', fontSize:13, color:'#cbd5e1', borderBottom:'1px solid #0f1117', whiteSpace:'nowrap' },
  tag: (color) => ({ padding:'3px 8px', borderRadius:20, fontSize:10, fontWeight:600, background:`${color}22`, color, border:`1px solid ${color}44` }),
  modal: { position:'fixed', inset:0, background:'rgba(0,0,0,0.7)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 },
  modalCard: { background:'#0e1420', border:'1px solid #1a2035', borderRadius:14, padding:28, width:480, maxWidth:'95vw' },
};

const linkStyle = { background:'none', border:'none', color:'#e2e8f0', fontWeight:700, cursor:'pointer', padding:0, fontSize:'inherit', textDecoration:'underline', textDecorationColor:'rgba(226,232,240,0.3)', textUnderlineOffset:2 };

export default function Projetos() {
  const navigate = useNavigate();
  const [projetos, setProjetos] = useState([]);
  const [search, setSearch] = useState('');
  const [detail, setDetail] = useState(null);
  const [erro, setErro] = useState('');

  const fetchData = () => {
    setErro('');
    api.get('/projetos/').then(r => setProjetos(r.data)).catch(() => setErro('Erro ao carregar dados. Tente atualizar a página.'));
  };
  useEffect(() => { fetchData(); }, []);

  const filtered = projetos.filter(p =>
    p.cliente_nome?.toLowerCase().includes(search.toLowerCase()) ||
    p.cidade?.toLowerCase().includes(search.toLowerCase())
  );

  const tagFor = (val, labelMap) => {
    if (!val) return <span style={{ color:'#1e2536', fontSize:11 }}>—</span>;
    const c = ALL_COLORS[val] || '#64748b';
    return <span style={S.tag(c)}>{labelMap[val] || val}</span>;
  };

  return (
    <div>
      <div style={S.heading}>Projetos / Obras</div>
      <div style={S.sub}>Acompanhe todas as instalações</div>

      {erro && (
        <div style={{ background:'rgba(248,113,113,0.1)', border:'1px solid rgba(248,113,113,0.3)', borderRadius:8, padding:'10px 14px', color:'#f87171', fontSize:13, marginBottom:14 }}>{erro}</div>
      )}

      <div style={S.filters}>
        <div style={S.searchBox}>
          <Search size={14} color="#475569" />
          <input style={S.searchInput} placeholder="Buscar cliente ou cidade..." value={search} onChange={e => setSearch(e.target.value)} />
        </div>
      </div>

      <div style={{ background:'#0e1420', border:'1px solid #1a2035', borderRadius:12, overflowX:'auto' }}>
        <table style={{ ...S.table, minWidth:1100 }}>
          <thead>
            <tr>
              <th style={S.th}>#</th>
              <th style={S.th}>Cliente</th>
              <th style={S.th}>Cidade</th>
              <th style={S.th}>Responsável</th>
              <th style={S.th}>Valor</th>
              <th style={S.th}>St. Vendedor</th>
              <th style={S.th}>St. Pós Venda</th>
              <th style={S.th}>St. Engenheiro</th>
              <th style={S.th}>St. Instalador</th>
              <th style={S.th}>St. Financeiro</th>
              <th style={S.th}>Início</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(p => (
              <tr key={p.id} style={{ cursor:'pointer' }}
                onClick={() => setDetail(p)}
                onMouseEnter={e => e.currentTarget.style.background='#111827'}
                onMouseLeave={e => e.currentTarget.style.background=''}>
                <td style={S.td}>#{p.id}</td>
                <td style={S.td}><button style={linkStyle} onClick={e => { e.stopPropagation(); navigate(`/jornada/${p.cliente}`); }}>{p.cliente_nome}</button></td>
                <td style={S.td}>{p.cidade}/{p.estado}</td>
                <td style={S.td}>{p.vendedor_nome}</td>
                <td style={S.td}><span style={{ color:'#f6c90e', fontWeight:600 }}>R$ {p.valor_total?.toLocaleString('pt-BR')}</span></td>
                <td style={S.td}>{tagFor(p.lead_status, STATUS_LABEL_LEAD)}</td>
                <td style={S.td}>{tagFor(p.pos_venda_status, STATUS_LABEL_POS)}</td>
                <td style={S.td}>{tagFor(p.engenheiro_status, STATUS_LABEL_ENG)}</td>
                <td style={S.td}>{tagFor(p.instalador_status, STATUS_LABEL_INST)}</td>
                <td style={S.td}>{tagFor(p.financeiro_status, STATUS_LABEL_FIN)}</td>
                <td style={S.td}>{p.venda_fechada_em || '—'}</td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr><td colSpan={11} style={{ ...S.td, textAlign:'center', color:'#475569', padding:32 }}>Nenhum projeto encontrado</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {detail && (
        <div style={S.modal} onClick={e => { if (e.target === e.currentTarget) setDetail(null); }}>
          <div style={S.modalCard}>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:16 }}>
              <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                <div style={{ fontSize:17, fontWeight:700, color:'#f6c90e' }}>Projeto #{detail.id}</div>
                <button style={{ background:'none', border:'1px solid #1a2035', borderRadius:6, color:'#60a5fa', cursor:'pointer', fontSize:11, padding:'3px 10px' }} onClick={() => { setDetail(null); navigate(`/jornada/${detail.cliente}`); }}>Ver Jornada</button>
              </div>
              <button style={{ background:'none', border:'none', cursor:'pointer', color:'#475569' }} onClick={() => setDetail(null)}><X size={18} /></button>
            </div>
            <div style={{ display:'flex', justifyContent:'center', marginBottom:16 }}>
              {tagFor(detail.lead_status, STATUS_LABEL_LEAD)}
            </div>
            {[
              ['Cliente', detail.cliente_nome],
              ['Cidade', `${detail.cidade}/${detail.estado}`],
              ['Responsável', detail.vendedor_nome],
              ['Geração', detail.kit_geracao ? `${detail.kit_geracao} kWh` : '—'],
              ['Valor Total', `R$ ${detail.valor_total?.toLocaleString('pt-BR')}`],
              ['Data de Início', detail.venda_fechada_em || '—'],
              ['Data Prevista', detail.data_prevista || '—'],
              ['Data de Conclusão', detail.data_conclusao || 'Em andamento'],
              ['Observações', detail.observacoes || '—'],
            ].map(([k, v]) => (
              <div key={k} style={{ display:'flex', justifyContent:'space-between', padding:'8px 0', borderBottom:'1px solid #1a2035', gap:12 }}>
                <span style={{ fontSize:12, color:'#475569', flexShrink:0 }}>{k}</span>
                <span style={{ fontSize:13, color:'#cbd5e1', textAlign:'right' }}>{v}</span>
              </div>
            ))}
            <div style={{ marginTop:16, textAlign:'right' }}>
              <button style={{ padding:'8px 16px', borderRadius:8, background:'#1a2035', border:'1px solid #2d3748', color:'#64748b', cursor:'pointer', fontSize:13 }} onClick={() => setDetail(null)}>Fechar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
